import { ChevronRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { currentNumerologyCycle } from "@/lib/energyCalculator";

const STORAGE="shane_metaphysical_profile";
const root={label:"Home",to:"/"};
const self={label:"Know Yourself",to:"/know-yourself"};
const others={label:"Understand Others",to:"/understand-others"};
const purpose={label:"Discover Purpose",to:"/discover-purpose"};
const explore={label:"Explore & Discover",to:"/explore"};
const tarot={label:"Tarot Play Therapy",to:"/tarot"};
const membership={label:"Membership",to:"/membership"};

const routeTrails={
  "/":[root],
  "/know-yourself":[root,self],
  "/understand-others":[root,others],
  "/discover-purpose":[root,purpose],
  "/guided-path":[root,self,{label:"Guided Path",to:"/guided-path"}],
  "/today":[root,self,{label:"Today",to:"/today"}],
  "/app/blueprint":[root,self,{label:"Blueprint",to:"/app/blueprint"}],
  "/app/energy":[root,self,{label:"Energy",to:"/app/energy"}],
  "/explore":[root,explore],
  "/tarot":[root,tarot],
  "/app/meanings":[root,explore,{label:"Meanings",to:"/app/meanings"}],
  "/app/teachers":[root,explore,{label:"Teachers",to:"/app/teachers"}],
  "/app/traditions":[root,explore,{label:"Traditions",to:"/app/traditions"}],
  "/app/sacral":[root,explore,{label:"Sacral & Kundalini",to:"/app/sacral"}],
  "/knowledge":[root,explore,{label:"Knowledge Atlas",to:"/knowledge"}],
  "/knowledge/intuitive":[root,explore,{label:"Intuition",to:"/knowledge/intuitive"}],
  "/wisdom":[root,explore,{label:"Wisdom",to:"/wisdom"}],
  "/methods":[root,explore,{label:"Methods",to:"/methods"}],
  "/app/connections":[root,explore,{label:"Connections",to:"/app/connections"}],
  "/reflect":[root,self,{label:"AI Conversation",to:"/reflect"}],
  "/membership":[root,membership],
  "/member":[root,membership,{label:"Member Access",to:"/member"}],
  "/payment/success":[root,membership,{label:"Confirmation",to:"/payment/success"}],
  "/privacy":[root,{label:"Privacy",to:"/privacy"}],
  "/sign-in":[root,{label:"Sign In",to:"/sign-in"}],
};

const personalDay=()=>{try{const profile=JSON.parse(localStorage.getItem(STORAGE));return profile?.input?.birthDate?currentNumerologyCycle(profile.input.birthDate).personalDay:null}catch{return null}};
const withContext=(pathname,search,steps)=>{
  const day=(pathname==="/today"||pathname==="/app/energy")?personalDay():null;
  if(day)return[...steps,{label:`Your Personal Day ${day}`}];
  if(pathname==="/reflect"&&new URLSearchParams(search).get("mode")==="journal")return[...steps,{label:"Journal"}];
  return steps;
};

const explanationLabel=(pathname)=>pathname.split("/").at(-1).replaceAll("-"," ").replace(/\b\w/g,(letter)=>letter.toUpperCase());
const routeSteps=(pathname)=>pathname.startsWith("/app/blueprint/explain/")?[root,self,{label:"Blueprint",to:"/app/blueprint"},{label:explanationLabel(pathname)}]:routeTrails[pathname]||[root];

export const LocationTrail=()=>{
  const{pathname,search}=useLocation();
  const[,setProfileRevision]=useState(0);
  useEffect(()=>{const refresh=()=>setProfileRevision((value)=>value+1);window.addEventListener("shane-profile-updated",refresh);return()=>window.removeEventListener("shane-profile-updated",refresh)},[]);
  const steps=withContext(pathname,search,routeSteps(pathname));
  return <nav className="location-trail" aria-label="Current location" data-testid="location-trail-container">
    <span className="location-trail-label">You are here</span>
    <ol>{steps.map((step,index)=>{
      const current=index===steps.length-1;
      return <li key={`${step.label}-${index}`}>
        {index>0&&<ChevronRight aria-hidden="true"/>}
        {current?<span aria-current="page" data-testid={`location-trail-current-${index+1}`}>{step.label}</span>:<Link to={step.to} data-testid={`location-trail-step-${index+1}`}>{step.label}</Link>}
      </li>;
    })}</ol>
  </nav>;
};